import { InjectionToken } from '@angular/core';

export const AUTH_CONFIG_ANGULAR = new InjectionToken('AUTH_CONFIG_ANGULAR');

export const AUTH_INTERCEPTOR_CONFIG = new InjectionToken(
  'AUTH_INTERCEPTOR_CONFIG',
);

export const TOKEN_API = '/api/token';
